// react
import React from 'react';


export default function BlockMap() {
    return (
        <div className="block-map block">
            <div className="block-map__body">
                <iframe
                    title="Google Map"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3508.1823401298157!2d-81.43322038482802!3d28.443919282492555!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88e77e7ecdd810cb%3A0xd7807cf2e6028ceb!2s8600%20Commodity%20Cir%2C%20Orlando%2C%20FL%2032819!5e0!3m2!1sen!2sus!4v1585288102814!5m2!1sen!2sus"
                    frameBorder="0"
                    scrolling="no"
                    marginHeight="0"
                    marginWidth="0"
                />
            </div>
        </div>
    );
}
